import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthComponent } from './auth/auth.component';
import { SimpleAuthGuard } from './guards/simple-auth.guard';
import { MainComponent } from './main/main.component';
const routes: Routes =[
  {
    path: '',
    pathMatch: 'full',
    component: MainComponent,
    canActivate: [SimpleAuthGuard]
  }, {
    path: '',
    component: MainComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('src/app/main/main.module').then(m => m.MainModule)
      }
    ]
  }, {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('src/app/auth/auth.module').then(m => m.AuthModule)
      }
    ]
  }, {
    path: '**',
    redirectTo: 'dashboard'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
